import Component from '../Component';
export default class SVGComponent extends Component {
}
